module.exports = __webpack_public_path__ + "static/img/13.aa32c5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/sp/13.png
// module id = NHul
// module chunks = 0